import { OnboardingTask } from '@tiendanube/common';
import { getPandaThumbnail } from './img/getPandaThumbnail';
import { TaskActionData, TaskData } from '../GenericTaskList';

export const promoteTaskDigest = (
  task: OnboardingTask,
): TaskData & TaskActionData => ({
  id: task.name,
  title: task.title,
  description: task.description,
  iconType: task.name,
  ctaText: task.ctaText,
  ctaLink: task.ctaLink,
  ctaExternal: task.ctaExternal,
  videoId: task.videoId,
  thumbnail: task.videoId ? getPandaThumbnail(task.name) : undefined,
});
